import { HTTPClient } from './api';
import getConfig from 'next/config';

const { CMS_URL } = getConfig().publicRuntimeConfig;

export const getCalculatorScript = async (idsCalculator, slug) => {
  const response = await HTTPClient(`/media/api/cms/calculator/?ids=${idsCalculator}&slug=${slug}`, {});

  if (response && !response.error) {
    return response;
  }

  return [];
};

export const loadScript = async (d) => {
  new Promise<void>((resolve) => {
    if (
      document.querySelector(`head > script[src="${d.src}"]`) !== null &&
      d.handle !== 'cp_calculatedfieldsf_builder_script'
    ) {
      return resolve();
    }

    const script = document.createElement('script');
    if (d.handle === 'cp_calculatedfieldsf_builder_script') {
      script.src = `${CMS_URL}calculator.js?cp_cff_resources=public&min=1`;
    } else {
      const source = d.src.indexOf('http') !== -1 ? d.src : `${CMS_URL}${d.src}`;
      script.src = source.replace(/([^:])(\/\/+)/g, '$1/');
    }

    script.async = false;
    script.defer = true;
    script.id = d.handle;

    document.head.appendChild(script);

    if (d.extra.data) {
      const scriptElement = document.createElement('script');
      scriptElement.text = d.extra.data;
      scriptElement.defer = true;
      document.head.appendChild(scriptElement);
    }

    script.onload = function () {
      resolve();
    };
  });
};

export const loadStyle = async (d) => {
  new Promise<void>((resolve) => {
    if (document.querySelector(`head > link[href="${d.src}"]`) !== null) return resolve();

    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.type = 'text/css';
    css.href = d.src;
    css.id = d.handle;
    document.head.appendChild(css);

    css.onload = function () {
      resolve();
    };
  });
};
